var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCemeraWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40679 2.04163H6.59339C6.17654 2.04163 5.96812 2.04163 5.7812 2.10696C5.66705 2.14685 5.5598 2.20425 5.46329 2.2771C5.30524 2.39639 5.18963 2.5698 4.95841 2.91663C4.84 3.09426 4.66544 3.35609 4.59587 3.42921C4.42348 3.61037 4.19743 3.73134 3.95106 3.7743C3.85163 3.79163 3.74489 3.79163 3.5314 3.79163C2.95969 3.79163 2.67384 3.79163 2.4401 3.85779C1.85541 4.0233 1.39842 4.48028 1.23291 5.06498C1.16675 5.29871 1.16675 5.58457 1.16675 6.15628V8.45829C1.16675 10.1082 1.16675 10.9331 1.67931 11.4457C2.19187 11.9583 3.01684 11.9583 4.66675 11.9583H9.33343C10.9833 11.9583 11.8083 11.9583 12.3209 11.4457C12.8334 10.9331 12.8334 10.1082 12.8334 8.45829V6.15628C12.8334 5.58457 12.8334 5.29871 12.7673 5.06498C12.6017 4.48028 12.1447 4.0233 11.5601 3.85779C11.3263 3.79163 11.0405 3.79163 10.4688 3.79163C10.2553 3.79163 10.1485 3.79163 10.0491 3.7743C9.80272 3.73134 9.57668 3.61037 9.4043 3.42921C9.33471 3.35609 9.16018 3.09426 9.04176 2.91663C8.81053 2.5698 8.69491 2.39639 8.53688 2.2771C8.44034 2.20425 8.33313 2.14685 8.21897 2.10696C8.03207 2.04163 7.82364 2.04163 7.40679 2.04163Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33343 7.58333C9.33343 8.87198 8.28873 9.91667 7.00009 9.91667C5.71142 9.91667 4.66675 8.87198 4.66675 7.58333C4.66675 6.29469 5.71142 5.25 7.00009 5.25C8.28873 5.25 9.33343 6.29469 9.33343 7.58333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0835 5.54163V5.54829",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCemeraWhite);
export default __webpack_public_path__ + "static/media/cemera_white.ba560d80da8685e290aee6891f5ad1c7.svg";
export { ForwardRef as ReactComponent };